const suffixRemove = (suffix: string, value: string) => {
  return value === '0' ? +value : +value.slice(0, value.length - suffix.length);
};

export default suffixRemove;
